import { useEffect, useState } from "react"
import { useSocketProvider } from "../../../../../Providers/SocketProvider"
import { Device, DeviceUpdate } from "../Types/Device"
import { Gateway, GatewayUpdate } from "../Types/Gateway"
import { useSocketRoom } from "./useSocketRoom"

type useMCPDeviceStatusProps = {
    gatewayId: number | undefined
}

export const useMCPDeviceStatus = ({ gatewayId }: useMCPDeviceStatusProps) => {
    const { getDataQuerySocket } = useSocketProvider()
    const socket = getDataQuerySocket("default", { namespace: "/gateways" })
    const [devices, setDevices] = useState<Device[]>([])
    const [gateway, setGateway] = useState<Gateway>()

    // Only listen to this gateway's updates
    useSocketRoom({ socket, room: gatewayId })

    // Subscribe to gateway status changes
    useEffect(() => {
        const listener = (gatewayUpdate: GatewayUpdate) => {
            if (gatewayUpdate.id !== gatewayId) {
                return
            }

            setGateway({
                id: gatewayUpdate.id,
                name: gatewayUpdate.gateway_name,
                status: gatewayUpdate.status,
            })
        }

        socket.on("gateway_update", listener)

        return () => {
            socket.off("gateway_update", listener)
        }
    }, [gatewayId, socket])

    // Subscribe to device status changes 
    useEffect(() => {
        const listener = (deviceUpdate: DeviceUpdate) => {
            if (deviceUpdate._gateway_id !== gatewayId) {
                return
            }

            const foundDevice = devices.find(device => device.id === deviceUpdate.id)

            const newDevice = {
                id: deviceUpdate.id,
                type: deviceUpdate.device_type,
                status: deviceUpdate.status
            }

            if (!foundDevice) {
                setDevices(previous => [...previous, newDevice])
            } else {
                setDevices(previous => previous.map(device => device.id === deviceUpdate.id ? newDevice : device))
            }
        }

        socket.on("device_update", listener)

        return () => {
            socket.off("device_update", listener)
        }
    }, [devices, gatewayId, socket])

    return { gateway, devices }
}